import makeSlice from '@web/slices/orderProcessor/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {
                data: {verificationKey},
            } = payload

            state.verificationKey = verificationKey
        })
    },
})

export default slice.reducer
